module.exports = __webpack_public_path__ + "img/icon_linkedin.3c6229c.svg";